export default __webpack_public_path__ + "static/media/brandplus.5248a9e8.jpg";